import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '@/store/hooks'
import { findMenuByPath, findMenuById } from '@/utils/menu'

// 获取父级菜单keys（支持多级菜单）
const getParentKeys = (menuList: any[], targetId: string, parentKeys: string[] = []): string[] => {
  for (const menu of menuList) {
    // 如果找到目标菜单，返回所有父级keys
    if (menu.id === targetId) {
      return parentKeys
    }
    // 如果有子菜单，递归查找
    if (menu.children && menu.children.length > 0) {
      // 将当前菜单id添加到parentKeys中，递归查找
      const found = getParentKeys(menu.children, targetId, [...parentKeys, menu.id])
      // 如果 found 不为空数组，说明在子树中找到了目标
      if (found.length > 0) {
        return found
      }
    }
  }
  return []
}

export const useMenuState = () => {
  const location = useLocation()
  const { menus } = useAppSelector((state) => state.user)
  const [selectedKeys, setSelectedKeys] = useState<string[]>([])
  const [openKeys, setOpenKeys] = useState<string[]>([])

  // 根据当前路径设置选中的菜单项
  useEffect(() => {
    const currentMenu = findMenuByPath(menus, location.pathname)
    if (currentMenu) {
      setSelectedKeys([currentMenu.id])
      // 设置展开的父级菜单
      const parentKeys = getParentKeys(menus, currentMenu.id)
      setOpenKeys(parentKeys)
    }
  }, [location.pathname, menus])

  return {
    selectedKeys,
    setSelectedKeys,
    openKeys,
    setOpenKeys,
  }
}

export default useMenuState

